import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { IconChevronLeft, IconCloseRoundStroked } from '@carnica/graphics';
import { selectImgPreviewTypeUpload } from "../../../../entities/message/model";
import { Button } from "../../../../shared/ui";
import { deleteMessagePreview } from "../../../../entities/univers";
export var ClosePreview = compose(connect(function (state) {
  var imgPreviewTypeLoad = selectImgPreviewTypeUpload(state);
  return {
    iconLeft: imgPreviewTypeLoad ? IconChevronLeft : IconCloseRoundStroked,
    onlyIcon: true,
    size: 'm',
    view: 'tertiary-invert'
  };
}, {
  onClick: function onClick() {
    return function (dispatch) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      dispatch(deleteMessagePreview());
    };
  }
}), withRenderFlag())(Button);